import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["manageBtn", "viewBtn", "editOnly", "viewOnly", "actions"]

  connect() {
    this.manageMode = false

    this.updateUI()
    document.addEventListener("turbo:frame-load", this.refreshTargets)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.refreshTargets)
  }

  toggle(event) {
    event.preventDefault()
    this.manageMode = !this.manageMode

    this.updateUI()
  }

  updateUI = () => {
    this.manageBtnTarget.classList.toggle("d-none", this.manageMode)
    this.manageBtnTarget.classList.toggle("btn-5", !this.manageMode)
    this.viewBtnTarget.classList.toggle("d-none", !this.manageMode)
    this.viewBtnTarget.classList.toggle("btn-5", this.manageMode)

    this.toggleTargets("editOnly", this.manageMode)
    this.toggleTargets("viewOnly", !this.manageMode)
    this.toggleTargets("actions", this.manageMode)
  }

  toggleTargets(targetName, show) {
    const plural = `${targetName}Targets`
    const has = `has${targetName.charAt(0).toUpperCase() + targetName.slice(1)}Target`

    if (!this[has]) {
      console.warn(`[manage-mode] No target found for '${targetName}'`)
      return
    }

    this[plural].forEach((el, i) => {
      el.classList.toggle("d-none", !show)
    })
  }

  refreshTargets = (event) => {
    if (!this.element.contains(event.target)) return

    this.updateUI()
  }
}
